import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
// import PriceTag from "../../../../../assets/images/tagPrice.PNG";
import { Markup } from "interweave";
import moment from "moment";
import axios from "axios";
import swal from "sweetalert";
import { Link, useHistory, useParams } from "react-router-dom";
import noImage from "../../../assets/images/settings/no-image.png";
import { Modal, Button } from "react-bootstrap";
import { serverInfo } from "../../../App";
import { useContext } from "react";
import LoaderPost from "../../Reuseable/LoaderPost";
// import './SouvenirMain.css'
// import StarShowcaseModal from "./StarShowcaseModal/StarShowcaseModal";
// import noImage from "../../../../../../";

const PrmotionalVideoView = () => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const { id } = useParams();

  const { history } = useHistory();

  const [promotionalView, setPromotionalView] = useState({});

  const [loading, setloading] = useState(true);
  // const [modalShowl, setModalShowl] = useState(false);

  // const {pdfFile} = promotionalView?.document;

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // const downloadPdf =()=>{
  //     alert(`${pdfFile}`);
  //     history.push(`${pdfFile}`);
  // }

  useEffect(() => {
    axios
      .get(`/api/audition-admin/promotional/video/view/${parseInt(id)}`)
      .then((res) => {
        // axios.get('/api/superstar/audition/promotional/video/view/${newId}').then((res) => {
        if (res.data.status === 200) {
          setPromotionalView(res.data?.eventView);
          // setStatus(res.data.action)
          setloading(false);
        }
      });
  }, [id]);

  return (
    <>
      {loading ? (
        <LoaderPost />
      ) : (
        <>
          <div className="m-3">
            <div className="card ">
              <img
                src={
                  promotionalView?.image
                    ? imageCdnUrl + promotionalView?.image
                    : noImage
                }
                alt=""
                className="BannerAGN"
              />
            </div>
            <div className="mt-3 row">
              <div className="col-md-8 ">
                <div className="row LeftGNA">
                  <div className="NotifyOver w-100 mb-5">
                    <h2
                      style={{
                        color: "gold",
                        fontSize: "20px",
                        fontWeight: "700",
                        padding: "15px 0",
                      }}
                    >
                      Promotional Instruction
                    </h2>
                    <p className="text-light pt-1">
                      <Markup content={promotionalView?.instruction} />
                    </p>
                  </div>
                </div>
                <div className="row LeftGNA">
                  <div className="NotifyOver w-100 mb-5">
                    <h2
                      style={{
                        color: "gold",
                        fontSize: "20px",
                        fontWeight: "700",
                        padding: "15px 0",
                      }}
                    >
                      Promotional Description
                    </h2>
                    <p className="text-light pt-1">
                      <Markup content={promotionalView?.description} />
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <ReactPlayer
                  className="ReactNAv"
                  url={
                    promotionalView?.video
                      ? videoCdnUrl + promotionalView?.video
                      : "https://www.youtube.com/watch?v=-X4ikwUwxoE"
                  }
                  width="100%"
                  // height="100%"
                  playing={false}
                  volume={1}
                  controls={true}
                  autoPlay
                />
                <div className="card card-bg px-3 py-4">
                  <p className="text-light pt-1">
                    {/* <Link to={ serverUrl + promotionalView?.document  }>        */}
                    {/* <button  className="btn BlueBtn w-100" onClick={downloadPdf}>Download</button> */}
                    {/* </Link> */}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PrmotionalVideoView;
